import { InsuranceModel} from './insurance.model';

export const insurances: InsuranceModel[] = [
  { name: 'Seleccionar', value: '' },
  { name: 'Todo riesgo sin franquicia', value: 'Todo riesgo sin franquicia' },
  { name: 'Todo riesgo con franquicia', value: 'Todo riesgo con franquicia' },
  { name: 'Terceros Completo', value: 'Terceros Completo' },
  { name: 'Terceros Básico', value: 'Terceros Básico' }
]
